//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';
import util from '@/lib/util';

export default {
    name: "couponDetail",
    components: {},
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            myCouponInfo: {coupon: {}},
            downloadUrl: util.ApiUrl + '/file/download/',
        };
    },
    methods: {
        getMyCoupon() {
            abp.ajax.get('/api/services/app/Coupon/GetMyCoupon?id=' + this.id).then(res => {
                this.myCouponInfo = {};
                this.myCouponInfo = res.data.result;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getMyCoupon()
        }
    }
}
